import Contact from '@/generated/classes/Contact';
import { typePicto } from "@/framework/base/helpers/Picto";
import { PictoTypes } from "@/generated/classes/Module";

export default class ContactExtend  extends Contact {
  
  constructor() {
    super();
  }

  public static getTitle (contact: Contact): string {
    return contact.prenom + ' ' + contact.nom;
  }

  public static getSubtitle (contact: Contact): string {
    return contact.mail;
  }

  public static getInfo (contact: Contact): string {
    return contact.numero;
  }

  public static getData (contact: Contact): string[] {
    const res: string[] = [];
    res.push(ContactExtend.getTitle(contact));
    res.push(ContactExtend.getSubtitle(contact));
    res.push(ContactExtend.getInfo(contact));
    res.push("100");
    return res;
  }

  public static getPicto (contact: Contact): string {
    return contact.prenom.substring(0, 1) + contact.nom.substring(0,1);
  }

  // eslint-disable-next-line
  public static getPictoType (contact: Contact): string {
    return typePicto(PictoTypes.INITIAL);
  }
}
